import React, { Dispatch, SetStateAction } from 'react'
import styles from "./FiltersOrdersRow.module.scss"
import Filter from '../Filter/Filter'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

interface Props {
    date: number[],
    setDate: Dispatch<SetStateAction<number[]>>
}

const FiltersOrdersRow:React.FC<Props> = ({date, setDate}) => {
    const { t } = useTranslation("translation", { keyPrefix: `interface` })    
    return (
        <div className={styles["filters-container"]}>
            <Filter
                text={t("date")}
                content="date"
                setChangeFilter={setDate}
                selectedValues={date}
                maxDate={new Date(moment().format("YYYY-MM-DD"))}
                titleModal={t("date")}
            />
        </div>
    )
}

export default FiltersOrdersRow